import React from 'react'
import '../assets/Head_Img.css';

class Head_Img extends React.Component {
  render() {
    return (
        <div class="home" id="Home" >  
            <div class="text"><p>HI, I'M JUSTIN EDOBOR</p></div>
              <h1>FRONT END<br />DEVELOPER</h1>
                <div class="btnhold">
                    <a href="#Project"><button class="headimg_btn font"><font>PORTFOLIO</font></button></a>
                    <a href="#Contact"><button class="headimg_btn">CONTACT</button></a>
                </div>
        </div>
    )
  }
}

export default Head_Img;